import { Component, OnInit, ElementRef, ViewChild, EventEmitter, HostBinding } from '@angular/core';
import { SLMap } from 'src/app/model/sl-map';

export interface IActionMapEntry {
	class: string;
	secondary: string;
	action: string;
}
export interface IActionMap {
	ul: IActionMapEntry;
	ur: IActionMapEntry;
	ll: IActionMapEntry;
	lr: IActionMapEntry;
}
@Component({
	selector: 'app-p-u-c',
	templateUrl: './p-u-c.component.html',
	styleUrls: ['./p-u-c.component.scss']
})
export class PUCComponent implements OnInit {

	public aniIcon = '';
	protected map: SLMap;
	@ViewChild('iconImage', { static: true }) iconImage: ElementRef;
	@ViewChild('point', { static: true }) point: ElementRef;
	@ViewChild('ul', { static: true }) ul: ElementRef;
	@ViewChild('ur', { static: true }) ur: ElementRef;
	@ViewChild('ll', { static: true }) ll: ElementRef;
	@ViewChild('lr', { static: true }) lr: ElementRef;
	@ViewChild('center', { static: true }) center: ElementRef;

	public actions: EventEmitter<any> = new EventEmitter<any>();
	protected actionMap: any = {
		ul: { class: 'fas fa-comment-alt', secondary: '', action: 'open-popup' },
		ur: { class: 'fas fa-times', secondary: '', action: 'close-puc' },
		ll: { class: 'fas fas fa-list', secondary: 'secondary fas fa-caret-down', action: 'send-to-results' },
		lr: { class: 'fas fas fa-list', secondary: 'secondary fas fa-caret-up', action: 'pull-from-results' }
	};
	constructor(private domNode: ElementRef<HTMLDivElement>) {

	}
	public get isClosed(): boolean {
		return $(this.point.nativeElement).hasClass('closed');
	}
	public set isClosed(state: boolean) {
		$(this.point.nativeElement).toggleClass('closed', state);
		if (state === false) {
			this.ul.nativeElement.focus();
		} else {
			this.center.nativeElement.focus();
		}

	}
	public get element(): HTMLElement {
		return this.domNode.nativeElement;
	}
	ngOnInit() {
	}

	Setup(map: SLMap) {
		this.map = map;
		this.aniIcon = this.map.environmentService.baseHRef + 'assets/images/location.png';
		this.iconImage.nativeElement.src = this.aniIcon;

		this.iconImage.nativeElement.addEventListener('click', (event) => {


		});
		$(this.domNode.nativeElement).on('click', (event) => {
			if (event.target === this.point.nativeElement) {
				this.isClosed = !this.isClosed;
				this.actions.emit({
					action: 'puc-click',
					isClosed: this.isClosed
				});
			}
		});
		this.ul.nativeElement.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
			this.actions.emit({
				action: this.actionMap.ul.action,
				isClosed: this.isClosed
			});
		});
		this.ur.nativeElement.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
			this.actions.emit({
				action: this.actionMap.ur.action,
				isClosed: this.isClosed
			});
		});
		this.ll.nativeElement.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
			this.actions.emit({
				action: this.actionMap.ll.action,
				isClosed: this.isClosed
			});
		});
		this.lr.nativeElement.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
			this.actions.emit({
				action: this.actionMap.lr.action,
				isClosed: this.isClosed
			});
		});
		this.center.nativeElement.addEventListener('click', (event) => {
			this.isClosed = !this.isClosed;
			this.actions.emit({
				action: 'puc-action-center',
				isClosed: this.isClosed
			});
		});
		this.point.nativeElement.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
		});
	}
	SetActionMap(actionMap: any) {
		for (const item in actionMap) {
			if (actionMap.hasOwnProperty(item)) {
				this.UpdateAction(item, actionMap[item]);
			}
		}
	}
	UpdateAction(item: string, action: IActionMapEntry) {
		this.ul.nativeElement.toggleClass(this.actionMap[item].class, false);
		this.ul.nativeElement.toggleClass(action.class, true);
		this.ul.nativeElement.toggleClass(this.actionMap[item].secondary, false);
		this.ul.nativeElement.toggleClass(action.secondary, true);
		this.actionMap[item] = action;
	}
  ToggleInteraction(is_on:boolean) {
    this.domNode.nativeElement.classList.toggle('not-interacting',!is_on);
  }


}
